import '../css/index.scss';
import intrinsicRatioVideos from './intrinsic-ratio-videos.js';
import threeDimensionalObjectViewer from './three-dimensional-object-viewer/threedimensionalobjectviewer.js';
import addStepsSlideAnimationToProjectsCarouselButtons from './add-steps-slide-animation-to-projects-carousel-buttons.js';
import addPlayPauseToHeroVideos from './add-play-pause-to-hero-videos.js';

function startAll() {
  // WordPress TwentyTwenty's responsive videos solution.
  intrinsicRatioVideos.init();
  // Start the 3D object components if they're present.
  threeDimensionalObjectViewer();
  // Add slide animation the the .projects-hero buttons.
  const projectsHeroButtonSelector = '.projects-hero .owl-item a';
  addStepsSlideAnimationToProjectsCarouselButtons(projectsHeroButtonSelector);
  // For WCAG 2.1 AA compliance the user must be able to stop any auto-playing media should they wish.
  addPlayPauseToHeroVideos();
}

if (document.readyState === 'loading') {
  // Loading hasn't finished yet.
  document.addEventListener('DOMContentLoaded', startAll);
} else {
  // `DOMContentLoaded` has already fired in the past.
  startAll();
}
